import { render, staticRenderFns } from "./AdminTrainingRetailerBrand.vue?vue&type=template&id=2f33a431&scoped=true"
import script from "./AdminTrainingRetailerBrand.vue?vue&type=script&lang=js"
export * from "./AdminTrainingRetailerBrand.vue?vue&type=script&lang=js"
import style0 from "./AdminTrainingRetailerBrand.vue?vue&type=style&index=0&id=2f33a431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33a431",
  null
  
)

export default component.exports